import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LottieModule } from 'ngx-lottie';

import { StrategyRoutes } from '../app-routing.module';
import { LayoutComponent } from './layout.component';
import { UnrulyNavigationComponent } from './unruly-navigation/unruly-navigation.component';
import { UnrulyNavigationItemComponent } from './unruly-navigation-item/unruly-navigation-item.component';
import { UnrulyBannerComponent } from './unruly-banner/unruly-banner.component';
import { SwitchPortalComponent } from './switch-portal/switch-portal.component';
import { AppBreadcrumbsComponent } from './app-breadcrumbs/app-breadcrumbs.component';
import { SpeardErrorComponent } from './spearad-error/spearad-error.component';
import { HeaderActionsComponent } from './header-actions/header-actions.component';
import { AuthGuard } from '../auth/_guards/auth.guard';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppLoadingComponent } from '../shared/_components/app-loading';

const layoutRoutes: StrategyRoutes = [
  {
    path: '', component: LayoutComponent, children: [
      {
        path: 'supply',
        loadChildren: () => import('./internal_layout.module').then(m => m.LayoutInternalRoutingModule),
        data: { routeSectionType: 'internal_preload', portalType: 'supply' }
      },
      {
        path: 'exchange',
        loadChildren: () => import('./exchange_layout.module').then(m => m.LayoutExchangeRoutingModule),
        data: { routeSectionType: 'lazy', portalType: 'exchange' }
      },
      {
        path: 'portal',
        loadChildren: () => import('./external_layout.module').then(m => m.LayoutExternalRoutingModule),
        data: { routeSectionType: 'lazy', portalType: 'portal' }
      },
      {
        path: 'partner',
        loadChildren: () => import('./partner_layout.module').then(m => m.LayoutPartnerRoutingModule),
        data: { routeSectionType: 'lazy', portalType: 'partner' }
      },
      { path: 'spearad', children: [
        { path: '**', component: AppLoadingComponent }
      ], data: { routeSectionType: 'external_preload', portalType: 'spearad' } }
    ], canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [
    LayoutComponent,
    UnrulyNavigationComponent,
    UnrulyNavigationItemComponent,
    UnrulyBannerComponent,
    SwitchPortalComponent,
    AppBreadcrumbsComponent,
    SpeardErrorComponent,
    HeaderActionsComponent,
    AppFooterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LottieModule,
    RouterModule.forChild(layoutRoutes)
  ]
})
export class BaseLayoutModule {}
